import { Injectable, inject } from '@angular/core';
import { of, take } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AppGlobalService } from '../services/app.global.service';
import { userData } from '../STORE/selectors/auth.selector';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private readonly appGlobal = inject(AppGlobalService);
  private readonly http = inject(HttpClient);
  private readonly store = inject(Store);

  public currentUser: any;

  public authenticate(): any {
    // Return user from store instead of localStorage
    return this.store.select(userData).pipe(take(1));
  }
  public getfsToken = () => {
    const api = `rest/v1/appuserprivileges/fstoken/${this.appGlobal.get('appId')}`;
    return this.http.get(api, { responseType: 'text' });
  };

  public setCurrentUser(data: any): void {
    this.currentUser = data;
  }

  public getcurrentUser(): any {
    return this.currentUser;
  }

  public logout(): void {
    // TODO
  }
}
